<div class="help-text-content">
  @for (block of blocks; track $index) {
    @if (block.type === 'paragraph') {
      <p class="help-text-paragraph">
        @for (segment of block.segments; track $index) {
          @if (segment.url) {
            <a
              class="font-semibold text-green-700 underline underline-offset-2 hover:text-green-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
              [href]="segment.url"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open help link (opens in a new tab)">{{ segment.text }}</a>
          } @else {
            <span>{{ segment.text }}</span>
          }
        }
      </p>
    } @else {
      <ul class="help-text-list">
        @for (item of block.items; track $index) {
          <li>
            @for (segment of item; track $index) {
              @if (segment.url) {
                <a
                  class="font-semibold text-green-700 underline underline-offset-2 hover:text-green-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
                  [href]="segment.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open help link (opens in a new tab)">{{ segment.text }}</a>
              } @else {
                <span>{{ segment.text }}</span>
              }
            }
          </li>
        }
      </ul>
    }
  }
</div>
